import React from 'react';

class Error extends React.Component {
  render() {
    return <h4>You don't have permission for this action.</h4>;
  }
}

export default Error;
